/**
 * @desc 批量保存或者更新bom
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: Array<defs.basics.PlmBomCreateRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/bom/plm/batchCreateOrUpdate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
